export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "open": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvert"])},
        "closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermé"])},
        "snoozed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En pause"])},
        "waiting_since": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["En attente depuis le ", _interpolate(_named("date"))])}
      },
      "en": {
        "open": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open"])},
        "closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Closed"])},
        "snoozed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Snoozed"])},
        "waiting_since": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Waiting since ", _interpolate(_named("date"))])}
      }
    }
  })
}
